var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraylinkdin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 0C13.7754 0 14.1993 0.175595 14.5118 0.488155C14.8244 0.800716 15 1.22464 15 1.66667V13.3333C15 13.7754 14.8244 14.1993 14.5118 14.5118C14.1993 14.8244 13.7754 15 13.3333 15H1.66667C1.22464 15 0.800716 14.8244 0.488155 14.5118C0.175595 14.1993 0 13.7754 0 13.3333V1.66667C0 1.22464 0.175595 0.800716 0.488155 0.488155C0.800716 0.175595 1.22464 0 1.66667 0H13.3333ZM12.9167 12.9167V8.5C12.9167 7.77949 12.6304 7.0885 12.121 6.57903C11.6115 6.06955 10.9205 5.78333 10.2 5.78333C9.49167 5.78333 8.66667 6.21667 8.26667 6.86667V5.94167H5.94167V12.9167H8.26667V8.80833C8.26667 8.16667 8.78333 7.64167 9.425 7.64167C9.73442 7.64167 10.0312 7.76458 10.25 7.98338C10.4688 8.20217 10.5917 8.49891 10.5917 8.80833V12.9167H12.9167ZM3.23333 4.63333C3.60464 4.63333 3.96073 4.48583 4.22328 4.22328C4.48583 3.96073 4.63333 3.60464 4.63333 3.23333C4.63333 2.45833 4.00833 1.825 3.23333 1.825C2.85982 1.825 2.5016 1.97338 2.23749 2.23749C1.97338 2.5016 1.825 2.85982 1.825 3.23333C1.825 4.00833 2.45833 4.63333 3.23333 4.63333ZM4.39167 12.9167V5.94167H2.08333V12.9167H4.39167Z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraylinkdin);
export default __webpack_public_path__ + "static/media/graylinkdin.bcbfbfb0009c593df8c4fe98ed87047d.svg";
export { ForwardRef as ReactComponent };